export const CORS_SERVER = "https://lit-cors.herokuapp.com/";
export const API = "https://medicord-server.herokuapp.com/";

export const FIREBASE_CONFIG = {
  apiKey: "AIzaSyA4Vn7ZUph5YNxjkjXz7A2LeP12MW2ix6I",
  authDomain: "medicord-bfd24.firebaseapp.com",
  projectId: "medicord-bfd24",
  storageBucket: "medicord-bfd24.appspot.com",
  messagingSenderId: "500139354346",
  appId: "1:500139354346:web:8a0a401a1716ff76248f93",
};
